'use client';
import { IRecommendedProductNudgeDataModel } from "@ninjacart/nc-nk-core";
import { useState } from "react";
import { getVideosRecommendedProducts } from "../api/kisaan/recommendedProduct";

interface UseRecommendedProductsResult {
  recommendedProducts: IRecommendedProductNudgeDataModel[] | null;
  isLoading: boolean;
  fetchRecommendedProducts: (videoId: string,type:string) => Promise<void>;
}

export const useRecommendedProducts = (): UseRecommendedProductsResult => {
  const [recommendedProducts, setRecommendedProducts] = useState<IRecommendedProductNudgeDataModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchRecommendedProducts = async (videoId: string,type:string) => {
    setIsLoading(true);
    try {
      const response = await getVideosRecommendedProducts(videoId,type);
      setRecommendedProducts(response);
    } catch (err: any) {
      console.error("Error fetching recommended products:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return { recommendedProducts, isLoading, fetchRecommendedProducts };
};
